import { useContext } from 'react';

import { RenderToHeaderContext } from './context';

export const useRenderMenu = () => {
  const { isMenuPinned, setMenuPinned, isMenuOpen, setMenuOpen } =
    useContext(RenderToHeaderContext);
  return { isMenuPinned, setMenuPinned, isMenuOpen, setMenuOpen };
};
